










































































































import { Component, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { UserDetailStateInfo, UserExternalCollaborationStatus } from '@/types'
import { InputCode } from '@/components/molecules/InputCode'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import {
  alertStore,
  authUserStore,
  modalErrorStore
} from '@/utils/store-accessor'
import { AlertMessage, ErrorMessage, externalCollaborationApi } from '@/api'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import { setErrorMessage } from '@/utils/error'
import dayjs from 'dayjs'
import { AtomTextField } from '@/components/atoms'

export interface UserExternalCollaborationItem {
  userId: string
  externalId: {
    input: string
    errorMessage: string
  }
  externalPassword: string
  registrationDate: {
    input: string
    errorMessage: string
  }
  registrationBranchCode: {
    input: string
    display: string
    errorMessage: string
  }
  status: UserExternalCollaborationStatus
}

export const defaultUserExternalCollaborationItem = (): UserExternalCollaborationItem => ({
  userId: '',
  externalId: {
    input: '',
    errorMessage: ''
  },
  externalPassword: '',
  registrationDate: {
    input: dayjs().format('YYYYMMDD'),
    errorMessage: ''
  },
  registrationBranchCode: {
    input: authUserStore.authUser.branchCode.code,
    display: authUserStore.authUser.branchCode.shortName,
    errorMessage: ''
  },
  status: UserExternalCollaborationStatus.Unused
})

@Component({
  components: { InputDatePicker, InputCode }
})
export default class UserExternalCollaboration extends ComponentVue {
  @Ref()
  externalIdTextField!: AtomTextField

  @PropSync('item', {
    type: Object,
    required: true
  })
  inputItem!: UserExternalCollaborationItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get externalIdMaxlength(): number {
    return 10
  }

  get cssCustomProperty(): any {
    return {
      '--height': this.height + 'px'
    }
  }

  get isIssued(): boolean {
    return this.inputItem.status === UserExternalCollaborationStatus.Issued
  }

  get isUnused(): boolean {
    return this.inputItem.status === UserExternalCollaborationStatus.Unused
  }

  get isIdInvalid(): boolean {
    return this.inputItem.status === UserExternalCollaborationStatus.IdInvalid
  }

  onInputExternalId(value: string): void {
    this.inputItem.externalPassword = ''
    this.resetErrorMessage(this.inputItem.externalId)

    if (value.length === this.externalIdMaxlength) {
      this.getPassword()
    }
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  async getPassword(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.inputItem.externalPassword = await externalCollaborationApi.getExternalPassword(
        {
          externalId: this.inputItem.externalId.input
        }
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          externalId: this.inputItem.externalId
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          onOkClick: () => {
            this.inputItem.externalId.input = ''
            this.externalIdTextField.atomTextField.focus()
          }
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalAlert.open({
          onOkClick: () => {
            this.inputItem.externalId.input = ''
            this.externalIdTextField.atomTextField.focus()
          }
        })
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async issueId(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await externalCollaborationApi.issueExternalCollaboration({
        externalId: this.inputItem.externalId.input,
        userId: this.inputItem.userId,
        registrationDate: this.inputItem.registrationDate.input,
        registrationBranchCode: this.inputItem.registrationBranchCode.input
      })

      this.$emit('updated')
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          externalId: this.inputItem.externalId,
          registrationDate: this.inputItem.registrationDate,
          registrationBranchCode: this.inputItem.registrationBranchCode
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async resetId(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await externalCollaborationApi.resetExternalCollaboration({
        externalId: this.inputItem.externalId.input
      })

      this.$emit('updated')
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          externalId: this.inputItem.externalId
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
